<div class="payment-page">


<div class="payment-card">


<h2>
Payment Preference
</h2>


<p class="subtitle">
Choose how customer should complete payment
</p>



<div class="options">


<label>
<input
type="radio"
name="payment"
value="Full Payment"
[(ngModel)]="paymentType">

<div>
<h4>Full Payment</h4>
<p>Customer pays complete amount</p>
</div>

</label>



<label>

<input
type="radio"
name="payment"
value="Advance"
[(ngModel)]="paymentType">


<div>

<h4>
Advance + Remaining
</h4>

<p>
Customer pays advance first
</p>

</div>

</label>



<label>

<input
type="radio"
name="payment"
value="Postpaid"
[(ngModel)]="paymentType">


<div>

<h4>
Postpaid
</h4>

<p>
Payment after service completion
</p>

</div>

</label>



<label>

<input
type="radio"
name="payment"
value="Cash On Hand"
[(ngModel)]="paymentType">


<div>

<h4>
Cash On Hand
</h4>

<p>
Offline payment
</p>

</div>

</label>


</div>




<div
class="advance-box"
*ngIf="paymentType==='Advance'"
>


<label>
Advance Amount
</label>


<input
type="number"
[(ngModel)]="advanceAmount"
placeholder="Enter amount">


</div>




<button
(click)="savePaymentPreference()">

Continue

</button>



</div>


</div>